export const MEMBERS_LOADED = "members/loaded"
export const MEMBER_ADDED = "members/memberAdded"
export const MEMBER_UPDATED = "members/memberUpdated"
export const MEMBER_DELETED = "members/memberDeleted"
export const MEMBERS_DELETED = "members/membersDeleted"